<!--左侧导航-->
<template>
  	<div class="navMenu">
	    <label v-for="navMenu in navMenus" >
	    	<!--只有一级菜单-->
		      <el-menu-item v-if="navMenu.childs==null&&navMenu.entity&&navMenu.entity.state==='ENABLE'"
		                    :key="navMenu.entity.id" :data="navMenu" :index="navMenu.entity.value" :route="navMenu.entity.value"
		                    background-color="#C6C6C6"
		      				text-color="#C6C6C6"
		      				active-text-color=""
		      				>
		          <!--图标-->
		        <!--标题-->
		        <template slot="title">
		        	<!--<span class="redDian">1</span>-->
		        	<span slot="title">{{navMenu.entity.alias}}</span>
		        	<i class="el-icon-arrow-right"></i>
		        </template>
		      </el-menu-item>
		      <!--有多级菜单-->
		      <el-submenu v-if="navMenu.childs&&navMenu.entity&&navMenu.entity.state==='ENABLE'"
		                     :key="navMenu.entity.id" :data="navMenu" :index="navMenu.entity.name" :route="navMenu.entity.value">
		        <template slot="title">
					<i :class="navMenu.entity.iconImg" class="iconImg"></i>
		          	<span> {{navMenu.entity.alias}}</span>
		        	<!--<span class="redDian">12</span>-->
		        </template>
		        <!--递归组件，把遍历的值传回子组件，完成递归调用-->
		        <nav-menu :navMenus="navMenu.childs"></nav-menu>
		      </el-submenu>
	    </label>
	    
 		</div>
</template>
 <!--
 	@value:路由
 	@alias:菜单名
 -->
<script>
  export default {
    name: 'NavMenu', //使用递归组件必须要有
    props: ['navMenus'], // 传入子组件的数据
    data() {
      return {
      }
    },
    methods: {
    }
  }
</script>
 
<style scoped>
.navMenu{
	width: 100%;
	background: #232531;
}
.yhgl{
	/*background: url(../assets/image/yhgl.png) no-repeat center center;*/
}
.hzsz{
	/*background: url(../assets/image/navHzszk.png) no-repeat center center;*/
	
}
</style>
<style>
	.el-menu{
		width: 100%;
	}
.navMenu .el-submenu__title{
	background: #232531 !important;
	color: #C6C6C6 !important;
	height: 63px;
	line-height: 63px;
	text-align:left;
	border-radius:inherit ;
	border-bottom:2px solid #1C1E2A ;
	padding: 0 !important;
	display: flex;
	align-items: center;
}
.navMenu .el-submenu__title>span{
	font-size: 17px;
}
.navMenu .el-submenu__title .iconImg{
	display: block;
	width: 22px;
	height: 22px;
	float: left;
	margin-right: 20px;
	margin-left: 42px;
	background-size:100% ;
}
.navMenu .el-submenu__title i.el-submenu__icon-arrow{
	font-weight: bold;
	color: rgba(46, 52, 88, 1);
	font-size: 14px;
	right: 50px;
}
.navMenu .el-menu-item{
	background: #1C1E2A !important;
	color: #626162 !important;
	position: relative;
	padding: 0;
	transition: .3s all;
	height: 50px;
	padding: 0 !important;
	display: flex;
	align-items: center;
}
.navMenu .el-menu-item:first-child{
	border-bottom: 2px solid #232429;
}
.navMenu .el-menu-item span{
	font-size:15px;
	margin-left: 87px;
}
.navMenu .el-menu-item .el-icon-arrow-right{
	font-size: 14px;
	font-weight: bold;
	color:  rgba(46, 52, 88, 1);;
	position: absolute;
	top: 50%;
	transform: translateY(-50%);
	right: 45px;
}
.navMenu .el-submenu.is-active .el-submenu__title{
	border-bottom:2px solid #1C1E2A ;
}
.navMenu .el-menu-item.is-active{
	background:#24376C   !important;
	color: #FFFFFF !important;
	font-weight: bold ;
}
.navMenu .el-menu-item.is-active i{
	/*transition: .3s all;*/
	/*transform: rotate(90deg);*/
	/*top: 40%;*/
	color: rgba(155, 155, 155, 1);
}
.redDian{
	display: block;
	/*width:19px;*/
	padding: 0 6px;
	height:19px;
	background:rgba(208,2,27,1);
	border-radius:6px;
	font-size:13px;
	font-weight:600;
	color:rgba(255,255,255,1);
	line-height:20px;
	text-align: center;
	position: absolute;
	top: 50%;
	transform: translateY(-50%);
	right: 80px;
}
 li.el-menu-item:hover{
	background:#24376C   !important ;
}
 li.el-menu-item:hover span{
    color: #FFFFFF !important;
    font-weight:500;
}
 li.el-menu-item:hover i.el-icon-arrow-right{
    color: rgba(155, 155, 155, 1);
}
div.el-submenu__title:hover span{
	color: #FFFFFF !important;
	
}
div.el-submenu__title:hover i.el-submenu__icon-arrow{
    color: rgba(155, 155, 155, 1);
}
</style>



// WEBPACK FOOTER //
// src/component/NavMenu.vue